import { Box, Tab, Tabs } from '@mui/material'
import { useTranslation } from 'react-i18next'
import { Link } from 'react-router-dom'

import { usePermissions } from '@/features/authorization/contexts/PermissionsContext'
import { WholesaleLayoutRouteInformation } from '@/features/wholesale/constants/routes'

type WholesaleTabsProps = {
  activeTab: string
}

export default function WholesaleTabs({ activeTab }: Readonly<WholesaleTabsProps>) {
  const { t } = useTranslation()
  const { permissions } = usePermissions()
  const canMutateWholesale = permissions.has('wholesaleMutation')

  const effectiveActiveTab =
    !canMutateWholesale && activeTab === WholesaleLayoutRouteInformation.IMPORT_TRADE.navigationPath
      ? WholesaleLayoutRouteInformation.PRODUCTION_PLAN_EXPORT.navigationPath
      : activeTab

  return (
    <Box sx={{ mt: 2, borderBottom: 1, borderColor: 'divider' }}>
      <Tabs aria-label="wholesale-tabs" value={effectiveActiveTab}>
        {canMutateWholesale && (
          <Tab
            component={Link}
            iconPosition="start"
            label={t('component.page_header.import_trade')}
            to={WholesaleLayoutRouteInformation.IMPORT_TRADE.routePath}
            value={WholesaleLayoutRouteInformation.IMPORT_TRADE.navigationPath}
          />
        )}
        <Tab
          component={Link}
          iconPosition="start"
          label={t('component.page_header.production_plan_export')}
          to={WholesaleLayoutRouteInformation.PRODUCTION_PLAN_EXPORT.routePath}
          value={WholesaleLayoutRouteInformation.PRODUCTION_PLAN_EXPORT.navigationPath}
        />
      </Tabs>
    </Box>
  )
}
